// pages/Unauthorized.tsx
const Unauthorized = () => (
  <div className="text-center mt-10 text-red-600 text-xl">
    ❌ You are not authorized to access this page.
  </div>
);

export default Unauthorized;